<template>
  <!--
    Top row of the portfolio summary card: the headline figure and the primary
    CTA. The label changes register across breakpoints per design — a gold
    uppercase eyebrow on tablet/desktop, a plain sentence-case title on mobile —
    so the casing and colour are breakpoint-conditional rather than two nodes.
  -->
  <div class="flex w-full items-start justify-between gap-5">
    <div class="flex flex-col gap-1.5">
      <p
        class="flex items-center gap-1.5 font-inter text-[17px] font-normal text-primary-0 md:text-xs md:font-bold md:uppercase md:tracking-[0.13em] md:text-secondary-5"
      >
        {{ PORTFOLIO_TERMS.totalActivePortfolio }}
        <InfoTooltip
          :label="PORTFOLIO_TERMS.totalActivePortfolio"
          :text="PORTFOLIO_INFO.totalActivePortfolio"
          side="bottom"
          icon-class="h-4 w-4 md:h-3.5 md:w-3.5"
        />
      </p>

      <div class="flex flex-wrap items-baseline gap-x-3.5 gap-y-1">
        <p
          class="font-league text-[34px] font-semibold leading-none tracking-[-0.02em] text-white md:text-[40px] md:font-bold min-[1120px]:text-[60px]"
        >
          {{ total }}
        </p>
      </div>
    </div>

    <!-- Mobile puts this CTA full-width at the foot of the card instead. -->
    <Button
      @click="$emit('add-investment')"
      icon
      label
      size="lg"
      variant="always-secondary-neo"
      class="hidden shrink-0 md:flex"
    >
      <template #icon>
        <Icon name="TrendingUp" :stroke-width="2" class="h-6 w-6" />
      </template>
      <template #label>{{ PORTFOLIO_TERMS.addInvestment }}</template>
    </Button>
  </div>
</template>

<script setup>
import { Button, Icon, InfoTooltip } from "@/components";
import { PORTFOLIO_TERMS, PORTFOLIO_INFO } from "@/constants/portfolioTerms";

defineProps({
  total: { type: String, required: true },
});

defineEmits(["add-investment"]);
</script>
